import { Mp9010Display } from '../../../shared/data-save/usage-history.entity';

/**
 * 失敗したAPIごとに MP9010 へ渡すタイトル・ステップバー。
 * 利用履歴の businessData.errorDisplay にも同じ値を保存する。
 *
 * @author CAP
 */
export const MP9010_DISPLAY = {
  /** マスタデータ取得 / 初期データ取得 / トークン切れ・transition */
  portal: { screenTitle: '変額保険ポータル', wizardDisplayType: '0', wizardLevel: '0' },
  /** 契約内容PDF取得API */
  contractPdf: { screenTitle: '契約内容PDF', wizardDisplayType: '0', wizardLevel: '0' },
  /** メール設定取得API / メール設定保存API */
  mail: { screenTitle: 'メール通知設定', wizardDisplayType: '0', wizardLevel: '0' },
  /** 解約時精算金取得API */
  cancellation: { screenTitle: '現在の解約時清算金', wizardDisplayType: '0', wizardLevel: '0' },
  /** 運用状況データ取得API */
  investment: { screenTitle: '運用状況', wizardDisplayType: '0', wizardLevel: '0' },
  /** 繰入割合変更初期データ取得API */
  allocationInit: { screenTitle: '保険料の繰入割合変更', wizardDisplayType: '0', wizardLevel: '0' },
  /** 繰入割合変更処理API */
  allocationProcess: { screenTitle: '保険料の繰入割合変更', wizardDisplayType: '1', wizardLevel: '0' },
  /** 繰入割合変更了解留意事項取得API */
  allocationCautions: { screenTitle: '保険料の繰入割合変更', wizardDisplayType: '1', wizardLevel: '1' },
  /** 繰入割合変更手続き確定API */
  allocationConfirm: { screenTitle: '保険料の繰入割合変更', wizardDisplayType: '1', wizardLevel: '2' },
  /** 積立金移転初期データ取得API */
  transferInit: { screenTitle: '積立金の移転', wizardDisplayType: '0', wizardLevel: '0' },
  /** 積立金移転変更処理API */
  transferProcess: { screenTitle: '積立金の移転', wizardDisplayType: '2', wizardLevel: '0' },
  /** 積立金移転了解留意事項取得API */
  transferCautions: { screenTitle: '積立金の移転', wizardDisplayType: '2', wizardLevel: '1' },
  /** 積立金移転手続き確定API */
  transferConfirm: { screenTitle: '積立金の移転', wizardDisplayType: '2', wizardLevel: '2' },
} as const satisfies Record<string, Mp9010Display>;
